<template>
  <Upload
    ref="uploader"
    v-model="val"
    :limit="20"
    multiple
    drag
    :paste-mask="pasteMask"
    :max-size="Math.pow(1024, 2) * 50"
    block-mode
    paste
    :http-request="uploadHandler"
    :before-remove="onBeforeRemove"
    :on-exceeded-size="onExceededSize"
    :trigger-text="$t('issue.attachmentField.trigger')"
    :class="b()"
  >
    <template #default>
      <div :class="b('custom-trigger')">
        <div
          :class="b('trigger-paste')"
          @click.stop="openPasteMask"
        >
          <span>
            <em class="zkicon iconxiala_xinjian" />
            {{ $t('issue.attachment.click') }}
          </span>
          <span>
            {{ $t('issue.attachment.pasteOrDrag') }}
          </span>
        </div>

        <div :class="b('add-file')">
          <em class="zkicon icondaochu" />
          {{ $t('issue.attachment.addFile') }}
        </div>
      </div>
    </template>

    <template #paste>
      <div :class="b('paste-mask-content')">
        <span>
          <em class="zkicon iconshangchuantupian" />
          {{ $t('issue.attachment.maskDesc') }}
        </span>
        <el-button
          plain
          type="primary"
          size="small"
          :class="b('exit-upload-btn')"
          @click="closePasteMask"
        >
          {{ $t('issue.attachment.exitUpload') }}
        </el-button>
      </div>
      <!-- 用于右键可出现粘贴选项 -->
      <el-input
        type="textarea"
        :class="b('transparent-mask')"
      />
    </template>

    <template
      #file-list="{ files: fList }"
    >
      <div
        v-for="file of fList.sort((a, b) => b.uploadTime - a.uploadTime)"
        :key="file.uid"
        :class="b('item')"
      >
        <el-avatar
          :size="30"
          :src="file.uploadUserHead"
          :class="b('avatar')"
        />
        <div :class="b('item-right')">
          <div :class="b('item-user')">
            <span :class="['zk-t-body', 'text-ellipsis', b('user-name')]">
              {{ file.uploadUserName }}
            </span>
            <span :class="b('action')">
              {{ $t('issue.attachmentField.action') }}
            </span>
            <span :class="b('time')">
              {{ file.uploadTime | formatDateTime }}
            </span>
          </div>
          <upload-item :file="file" />
        </div>
      </div>
    </template>
  </Upload>
</template>

<script>
import axios from 'axios';
import { removeAttachment } from '@/api/home';
import theme from '@zk/theme/lib/variables.scss';
import http from 'common-module/src/util/http';

const CancelToken = axios.CancelToken;
export default {
  name: 'TodoUpload',
  props: {
    todoListId: {
      type: [String, Number],
      default: 0
    },
    fileList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      bemNS: theme.bemNS,
      val: [],
      pasteMask: false
    };
  },
  watch: {
    fileList: {
      immediate: true,
      handler(value) {
        this.val = value;
      }
    },
    val(n) {
      this.$emit('update:fileList', n);
    }
  },
  methods: {
    /**
     * 请求后台上传文件
     * @param item 当前文件对象
     * @param cancelToken 取消上传token
     * @returns {*}
     */
    doUploading(item, cancelToken) {
      console.log('d', item, cancelToken);
      const data = new FormData();
      data.append('files', item.file);
      return http.httpAxios({
        url: '/sys-file/upload/todolist-attachment',
        method: 'post',
        params: {
          todoListId: this.todoListId || 0
        },
        data,
        onUploadProgress(e) {
          const percent = e.loaded / e.total * 100 | 0;
          item.onProgress({ percent });
        },
        cancelToken
      });
    },
    /**
     * 复写上传实现
     * @param item
     * @returns {Promise<unknown>}
     */
    uploadHandler(item) {
      const source = CancelToken.source();
      const p = new Promise((resolve, reject) => {
        item.onProgress({ percent: 0 });
        this.doUploading(item, source.token).then((res) => {
          const r = res?.successVOS?.[0];
          if (!r) {
            reject(new Error('上传失败', res));
            return;
          }
          resolve({
            success: true,
            ...res,
            result: {
              ...r,
              id: r.fileKey,
              type: r.fileType,
              url: r.originalUrl || r.fileDownloadPath,
              avatar: r.uploadUserHead,
              userName: r.uploadUserName
            }
          });
        }).catch(()=>{
          source.cancel();
        });
      });
      // 取消上传
      p.abort = () => source.cancel();
      return p;
    },
    /**
     * 删除前钩子
     * @param item
     * @returns {Promise<*|boolean|void>}
     */
    async onBeforeRemove(item) {
      await this.$msgbox.confirm(this.$t('issue.Confirm_to_remove_attachment'), this.$t('issue.Confirm'), {
        cancelButtonText: this.$t('issue.Cancel'),
        confirmButtonText: this.$t('issue.Confirm'),
        type: 'warning'
      });
      if (item.status === 'success' && item.id) {
        return removeAttachment({
          fileKeys: [item.fileKey],
          linkModule: 'todolist',
          linkEntity: 'attachment',
          linkId: this.todoListId,
          relIds: [item.relId]
        });
      }
      return Promise.resolve();
    },
    /**
     * 超过文件大小钩子
     * @param file
     * @param fileList
     * @param msg
     */
    onExceededSize(file, fileList, msg) {
      this.$message.warning(this.$t('fileMaxSizeMessage', { size: msg }));
    },
    openPasteMask() {
      this.$refs.uploader?.onMouseEnter();
      this.pasteMask = true;
    },
    closePasteMask() {
      this.$refs.uploader?.onMouseLeave();
      this.pasteMask = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@include b(todo-upload) {
  width: 100%;
  ::v-deep {
    .el-upload-dragger {
      border: none;
      width: auto;
      height: auto;
      overflow: unset;
      @include when(dragover) {
        border: 1px dashed var(--primary-color);
      }
    }
    .zk-upload__trigger {
      width: 140px;
    }
    .zk-upload__expand {
      display: none;
    }
    .zk-upload__block-wrap {
      flex-direction: column;
      align-items: stretch;
      flex-wrap: nowrap;
      max-height: unset;

      div:first-child {
        margin-right: 0;
      }

      .el-upload {
        display: inline-block;

        .zk-upload__trigger {
          width: unset;
          flex-direction: row;
          height: 50px;
          .zk-upload__trigger-icon {
            font-size: 16px;
            margin-right: 4px;
            margin-bottom: 0;
          }
        }
      }
    }
  }
  @include e(item) {
    display: flex;
    width: 100%;
    margin-top: 20px;
    &:first-child {
      margin-top: 0;
    }
    ::v-deep {
      .zk-upload-item {
        margin-top: 6px;
      }
    }
  }
  @include e(avatar) {
    margin-right: var(--m-small);
  }
  @include e(item-right) {
    flex: 1;
  }
  @include e(item-user) {
    display: flex;
    align-items: center;
    span {
      line-height: 18px;
      font-size: var(--size-font-9);
      margin-left: var(--p-default);
      display: inline-block;
      &:first-child {
        margin-left: 0;
      }
    }
  }
  @include e(user-name) {
    font-weight: var(--weight-font-Blod);
    max-width: 150px;
  }
  @include e(action) {
    font-weight: var(--weight-font-Semiblod);
    color: var(--font-color-2);
  }
  @include e(time) {
    font-weight: var(--weight-font-Semiblod);
    color: var(--font-color-3);
  }

  @include e(custom-trigger) {
    border: 1px solid var(--color-border-2);
    border-radius: var(--m-mini);
    padding: 12px 12px 0 12px;
  }
  @include e(add-file) {
    max-height: 35px;
    &,
    em.zkicon {
      font-size: var(--size-font-9);
    }
    &:hover {
      color: var(--primary-color);
      em[class*='zkicon'] {
        color: var(--primary-color);
      }
    }
  }

  ::v-deep .zk-upload__dropzone {
    background: rgba(236, 232, 255, 0.75);
  }

  @include e(trigger-paste) {
    background: var(--gray-1);
    border: 1px dashed #dedede;
    min-width: 253px;
    padding: 16px 0;
    border-radius: var(--m-mini);
    font-size: var(--size-font-9);
    color: var(--font-color-1);
    > span {
      display: block;
      width: 100%;
      line-height: 1.2;
      &:first-child {
        margin-bottom: 4px;
      }
    }
    em.zkicon {
      font-size: var(--size-font-9);
      color: var(--purpleGray-7);
    }

    &:hover {
      border-color: var(--primary-color);
      background: var(--brand-transparent-hover);
      &,
      span,
      em[class*='el-icon-'] {
        color: var(--primary-color);
      }
      & + .zk-attachment-field-component__add-file {
        &,
        em[class*='zkicon'] {
          color: var(--font-color-1);
        }
      }
    }
  }
  @include e(paste-mask-content) {
    text-align: center;
    position: relative;
    z-index: 300;
    > span {
      display: block;
      width: 100%;
      em.zkicon {
        color: var(--font-color-1);
      }
    }
  }
  @include e(exit-upload-btn) {
    margin-top: var(--m-small);
    &,
    &:hover {
      background: none !important;
    }
    &:hover {
      color: var(--brand-color-6);
      border-color: var(--brand-color-6);
    }
  }
  @include e(transparent-mask) {
    &,
    ::v-deep .el-textarea__inner {
      position: absolute;
      z-index: 100;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: default;
    }
  }
}
</style>
